import { getMetaData, getNotificationState } from 'common/header/notifications/hooks/mappers/impl/shared';
import {
  type MappedNotification,
  type NotificationMapper,
  type NotificationMapperOptions
} from 'common/header/notifications/Notifications.types';

export const supplierRelationshipChangeMapper: NotificationMapper = (notification, options) => {
  return {
    ...notification,
    ...getTitle(notification, options),
    to: `/${options.tenantCode}/supplier/${notification.resourceUid}`
  };
};

function getTitle(
  notification: MappedNotification,
  options: NotificationMapperOptions
): { title: string; iconType: MappedNotification['iconType'] } {
  const metadata = getMetaData(notification);
  const state = getNotificationState(notification.status);
  const supAccepted = metadata.value('STATUS') === 'ACCEPTED';
  let title: string;
  if (state.isError) {
    title = options.intl.supplierInvitationTitleError;
  } else {
    title = supAccepted ? options.intl.supplierInvitationTitleAccepted : options.intl.supplierInvitationTitleDeclined;
  }

  return { title, iconType: supAccepted ? 'INFO' : 'FAILURE' };
}
